import { render } from "./spinner1.vue?vue&type=template&id=0741b8b2&scoped=true"
const script = {}

import "./spinner1.vue?vue&type=style&index=0&id=0741b8b2&lang=scss&scoped=true"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0741b8b2"]])

export default __exports__